// src/com/rtd_term_pos/RtdTermPosLine.js
import React, { useState, useEffect, useRef } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle } from '../../value/AppConst';
import { SorterLabel } from '../../common/SorterLabel';

const LineBox = styled(Box)({
    borderBottom: AppStyle.BorderCCC,
    minHeight: 50, boxSizing: 'border-box', // width: '90%',
    // display: 'flex', alignItems: 'center', // padding: '0.1rem 0 0.1rem 0',
});

const UpperRow = styled(Box)({
    display: 'flex', alignItems: 'center', paddingTop: '0.2rem',
});

const VehPlates = styled(Box)({
    width: 120
});

const GpsTime = styled(Box)({
    flexGrow: 1, textAlign: 'center', fontSize: '0.9rem', fontFamily: 'monospace',
});
const Driver = styled(Box)({ width: 70, textAlign: 'center' });
const Speed = styled(Box)({width: 50, textAlign: 'center', fontSize: '0.9rem'});

const Location = styled(Box)({
    fontSize: '0.85rem', padding: '0.3rem',
    textAlign: 'left', overflow: 'hidden', width: '90vw', marginLeft: '1rem', // backgroundColor: 'yellow',
    textOverflow: 'ellipsis', whiteSpace: 'nowrap',
});

/**
 * 차량위치 리스트의 한 줄
 */
export default function RtdTermPosLine({
    item,
    index,
    itemSelected,
    onClick,
    onClickSorter, // (id, sortState) => void
    idSorted, // id of the column that is currently sorted
}) {
    const [isVisible, setIsVisible] = useState(false);
    const itemRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update state when intersection status changes
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null, // viewport
                rootMargin: '0px',
                threshold: 0.1, // trigger when 10% of the element is visible
            }
        );

        const currentRef = itemRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        // Cleanup observer on component unmount
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const renderLine = () => {
        return(
            <>
            <UpperRow>
                <VehPlates>{item.vehPlates}</VehPlates>
                <Driver>{item.driverName}</Driver>
                <Speed>{item.speed}</Speed>
                <GpsTime>{item.gpsTime}</GpsTime>
            </UpperRow>
            <Location>{item.location}</Location>
            </>
        );
    };

    if(!item) {
        return(
            <UpperRow style={{
                backgroundColor:AppStyle.PrimaryRGB, color:'white', textAlign:'center',
                minHeight: 34,
                display: 'flex', alignItems: 'center',
            }}>
                    <VehPlates>
                        <SorterLabel
                            id="vehPlates"
                            idSorted={idSorted}
                            label="차량번호"
                            onClick={onClickSorter}
                        />
                    </VehPlates>
                    <Driver>
                        <SorterLabel
                            id="driverName"
                            idSorted={idSorted}
                            label="운전자"
                            onClick={onClickSorter}
                        />
                    </Driver>
                    <Speed>속도</Speed>
                    <GpsTime>
                        <SorterLabel
                            id="gpsTime"
                            idSorted={idSorted}
                            label="최종보고"
                            onClick={onClickSorter}
                        />
                    </GpsTime>
            </UpperRow>
        );
    }

    return(
        <LineBox
            ref={itemRef}
            onClick={() => {
                onClick(item, index);
            }}
            style={{
                backgroundColor: item.vehInfoSeq===itemSelected.vehInfoSeq ? '#e0f7fa' : index % 2 === 0 ? '#ffffff' : '#f9f9f9',
            }}
        >
            {isVisible ? renderLine() : null}
        </LineBox>
    );
};